package com.merkost.handpass.api.dto.listing

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SellerInfoDto(
    val id: String,
    val slug: String? = null,
    @SerialName("full_name") val fullName: String,
    @SerialName("avatar_url") val avatarUrl: String? = null,
    val rating: Double? = null,
    @SerialName("total_sales") val totalSales: Int = 0,
    @SerialName("phone_verified") val phoneVerified: Boolean = false,
    @SerialName("is_verified") val isVerified: Boolean = false,
    @SerialName("joined_at") val joinedAt: String? = null,
    @SerialName("review_count") val reviewCount: Int? = null,
    @SerialName("has_handpass_partner_badge") val hasHandpassPartnerBadge: Boolean = false
)
